module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAYBDQz3Ag8O/gwFCgn0BiirRMAAAAo0lEQVQoz73QOw6CUBCF4cFCEzU+VoCFlSUb0cpWl2PtStwaMYRQkIHMvcw/YQGchnMnX8ORBXP4/Hjc+vTdaO231V1P+WjFcp36TrUG/nMtnY6wysci0QQvMqNAKBAKhAIjBUIbYKDAQB2Sl+rXH/w1Y4V5GAvYQYFVCWWeAhp2hIYdoUBogFAgFGiBbg06fVs5GnT6sLIHjrRNUs5C1k9ZMAN4vIInYgOXawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/icon_close_mobile.png
// module id = yApr
// module chunks = 1